import BaseEntity from './BaseEntity';
export default class ESLintError extends BaseEntity {
    constructor(data) {
        super();
        this.errorMessage = this.parseProperty(data, 'errorMessage');
    }
    isMissingPlugin() {
        const pluginRegex = new RegExp(/ESLint couldn't (find|determine) the (plugin|config) "(?<pluginName>.*)"/);
        const pluginName = this.errorMessage.match(pluginRegex)?.groups?.pluginName;
        return pluginName ?? false;
    }
}
